import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { isMobile } from "@/utils/responsive";

//

// 完整 element-ui
// import ElementUI from "element-ui";
// Vue.use(ElementUI);
// element-ui-----------------------------start
import { Tabs as ElTabs, TabPane, Carousel, CarouselItem } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElTabs);
Vue.use(TabPane);
Vue.use(Carousel);
Vue.use(CarouselItem);
// element-ui-----------------------------end

// 引入animate.css
import "animate.css";

// 引入使用WOW.js工具-----------------------------start
import Wow from "@/utils/wow";
Vue.use(Wow);
// 引入使用WOW.js工具-----------------------------end

// 全局样式
import "@/assets/styles/reset.css";
import "@/assets/styles/common.scss";

// 全局数据
import * as publicData from "@/utils/publicData";
Vue.prototype.$publicData = publicData.publicData;

// 引入flexible.js
import "amfe-flexible";

// vant-----------------------------start
import { Collapse, CollapseItem, Tab, Tabs, Swipe, SwipeItem } from "vant";
import "vant/lib/index.css";
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Swipe);
Vue.use(SwipeItem);
// vant-----------------------------end

// swiper工具================================start
// import Swiper from "swiper";
// import "swiper/css/swiper.css";
// Vue.prototype.Swiper = Swiper;
// import swiper from "@/utils/swiper";
// Vue.prototype.$swiper = swiper;
// swiper工具================================end

// 根据设备类型给body添加class
if (isMobile()) {
  document.body.classList.add("mobile");
} else {
  document.body.classList.add("pc");
}

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
